module.exports = "<p>Article for the Seattle Art Museum:<br> <a href=http://samblog.seattleartmuseum.org/2018/06/sam-gallery-jennifer-zwick/ >SAM Gallery Artists on Seattle: Jennifer Zwick</a><br> <br> Article by Brett Hamil in Seattle’s Child Magazine:<br> <a href=http://www.seattleschild.com/A-little-tiny-hiccup-Jennifer-Zwick-on-Art-and-Children/ >“A ‘little tiny hiccup’: Jennifer Zwick on art and children.”</a><br> <br> Just launched: <a href=http://thelotterygrant.com>The Lottery Grant… <i>the website!</i></a></p> ";


//////////////////
// WEBPACK FOOTER
// ./application/text/currentPress.md
// module id = 552
// module chunks = 0